export const SKILL_META = {
  commonSkills: { title: "Common Skills*", description: "Soft skills common across jobs." },
  definingSkills: { title: "Defining Skills*", description: "Specialized skills for core tasks." },
  distinguishingSkills: { title: "Distinguishing Skills*", description: "Advanced but less frequent." },
  salaryBoostingSkills: { title: "Salary Boosting Skills*", description: "High-value skills that boost pay." }
};

export const emptyCat = () =>
  Object.fromEntries(Object.entries(SKILL_META).map(([k, v]) => [k, { ...v, skills: [] }]));

export const initState = {
  selectedSkills: new Set(),
  targetOccupation: "",
  isLoadingSkills: false,
  skillsError: null,
  skillsLoaded: false,
  targetOccupationOptions: [],
  isLoadingTargetCareers: false,
  isInitialCareerFetch: false,
  currentView: "selection", // "selection" or "comparison"
  skillsData: null,
  isSaving: false,
  activeTab: "gap"
};
